@use '@/scss/underscore' as _;

.suspended {
  background: var(--color-error-container);
  color: var(--color-text);
  font: var(--font-label-3);
  padding: _.unit(0.5) _.unit(1.5);
  border-radius: 10px;
}
